import { useState } from "react";
import ServiceCard from "./serviceCard";
import stravovani from "../img/card/stravovani.jpg";
import rozvoz from "../img/card/rozvoz.jpg";
import dohled from "../img/card/dohled.jpg";
import hygiena from "../img/card/hygiena.jpg";
import doprava from "../img/card/doprava.jpg";
import zdravi from "../img/card/zdravi.jpg";
import pomoc from "../img/card/pomoc.jpg";
import CollapsibleServices from "./CollapsibleServices";
import ModalGallery from "./ModalGallery";
//import { Fragment } from 'react'

const Services = () => {
  const [visibleParts, setVisibleParts] = useState({});
  const [isGalleryModalOpen, setIsGalleryModalOpen] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState(null);

  // Funkce pro otevření galerie s konkrétním ID karty
  const openGallery = (id) => {
    setSelectedCardId(id);
    setIsGalleryModalOpen(true);
  };

  const cards = [
    {
      id: 1,
      image: stravovani,
      alt: "Pomoc při zvládání běžných úkonů péče o vlastní osobu",
      text: "Zvládání běžných úkonů péče o vlastní osobu - pomoc a podpora při podávání jídla a pití, pomoc při oblékání a svlékání, aj.",
    },
    {
      id: 2,
      image: hygiena,
      alt: "Pomoc při osobní hygieně",
      text: "Pomoc při osobní hygieně - pomoc při úkonech os. hygieny, při základní péči o vlasy a nehty, aj.",
    },
    {
      id: 3,
      image: rozvoz,
      alt: "Poskytnutí stravy nebo pomoc při zajištění stravy, dovoz obědů",
      text: "Poskytnutí stravy nebo pomoc při zajištění stravy, dovoz obědů",
    },
    {
      id: 4,
      image: pomoc,
      alt: "Pomoc při zajištění chodu domácnosti",
      text: "Pomoc při zajištění chodu domácnosti - nákupy, pochůzky, úklid, aj.",
    },
    {
      id: 5,
      image: doprava,
      alt: "Zprostředkování kontaktu se společenským prostředím",
      text: "Zprostředkování kontaktu se společenským prostředím - doprovod , doprava",
    },
    {
      id: 6,
      image: dohled,
      alt: "Pomoc při uplatňování práv, oprávněných zájmů a při obstarávání osobních záležitostí",
      text: "Pomoc při uplatňování práv, oprávněných zájmů a při obstarávání osobních záležitostí",
    },
    {
      id: 7,
      image: zdravi,
      alt: "Dohled - pomoc při zajištění bezpečí a možnosti setrvání v přirozeném sociálním prostředí.",
      text: "Dohled - pomoc při zajištění bezpečí a možnosti setrvání v přirozeném sociálním prostředí.",
    },
  ];

  const containerClasses =
    "md:w-3/4 p-2 md:p-3 mx-auto text-lg my-1 transition-all duration-500";

  const styles = {
    classes: {
      divL: "md:w-3/4 p:2 p-2 md:p-3 mx-auto text-lg my-1 transition-all duration-500",
      h3: "text-xl mb-1 ms-4",
      ul: "list-disc px-4 md:px-6 my-2",
    },
  };

  const goals = [
    {
      id: 1,
      text: "Pomáhat naplňovat ty osobní individuální cíle našich klientů, kterých by chtěli dosáhnout v souvislosti s poskytováním služby.",
    },
    {
      id: 2,
      text: "Zajistit či zprostředkovat klientům veškeré dostupné informace k možnému řešení jejich životní situace.",
    },
    {
      id: 3,
      text: "Podporovat nezávislost, samostatnost klientů. (Poskytovat klientům takovou míru podpory, aby si co nejdéle udrželi přiměřenou fyzickou a psychickou kondici - nepodporovat přemrštěnou péčí závislost).",
    },
    {
      id: 4,
      text: "Pomáhat vyloučit nebo podstatně snížit sociální izolaci klientů, napomáhat s realizací zájmů klientů.",
    },
    {
      id: 5,
      text: "Poskytovat služby klientům dostupné: - místně - ve spádové oblasti, - finančně (příp. poskytnout pomoc s řešením finanční situace klienta dle jeho potřeb).",
    },
  ];

  const targetGroups = [
    {
      id: 1,
      text: "Senioři - občané, kteří dosáhli věku, rozhodného pro přiznání starobního důchodu, a vzhledem ke svému věku a zdravotnímu stavu mají sníženou soběstačnost a potřebují pomoc další osoby k zajištění svých potřeb při péči o svou osobu a domácnost.",
    },
    {
      id: 2,
      text: "Osoby s chronickým onemocněním - občané, kteří z důvodu svého chronického onemocnění mají sníženou soběstačnost a potřebují pomoc při zajištění svých potřeb.",
    },
    {
      id: 3,
      text: "Osoby s jiným zdravotním postižením - občané, kteří z důvodu svého zdravotního postižení mají sníženou soběstačnost a potřebují pomoc další osoby k zajištění svých potřeb.",
    },
    {
      id: 4,
      text: "Rodiny, ve kterých se narodily současné 3 nebo více dětí nebo v rozmezí 2 let se opakovaně narodily současně 2 děti (služba se poskytuje do 4 let věku dětí bez úhrady).",
    },
    {
      id: 5,
      text: "Rodinám s dětmi - v případech, kdy rodina potřebuje pomoc v péči o děti a nemůže ji sama zabezpečit z důvodů vážných překážek (např. nemoc, rekonvalescence, lázeňská léčba apod.) rodičů nebo osob odpovědných za výchovu dětí (Za poskytování pečovatelské služby hradí klienti úhradu za provedené úkony ve výši sjednané ve smlouvě uzavřené s poskytovatelem služby).",
    },
  ];

  // Upozornění pod jídelníčkem
  const MenuInfo = () => {
    return (
      <div className="my-3 bg-gray-300 text-neutral-900 rounded-md shadow-lg w-fit mx-auto p-5">
        <div className="text-center mb-2 text-2xl font-bold">
          Alergeny rozdány, jinak na vyžádání u vedoucí.
        </div>
        <div className="text-center mb-2 text-2xl">
          Změna jídelníčku vyhrazena!!!
        </div>
        <div className="text-center mb-2">
          Jídlo je určeno k bezprostřední konzumaci!!!
        </div>
      </div>
    );
  };

  // datum pro jídelníček - aktuální týden

  const menuDate = "01.06.2026 do 12.06.2026";

  // dada pro jídelníček
  const menu1 = [
    {
      id: 1,
      day: "Pondělí",
      date: "01.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Květáková",
          weight: "0.3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Dančí guláš, HK ",
          weight: "100/200",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 2,
          name: "Studentský řízek, brambor, tatarka ",
          weight: "100/300",
          alergens: "1,3,7,9",
        },
      ],
    },
    {
      id: 2,
      day: "Úterý",
      date: "02.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Slepičí vývar s bylinkovými noky ",
          weight: "0,3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Pečené kuře, brambor ",
          weight: "220/300",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 2,
          name: "Džuveč z vepř. masa, sýr ",
          weight: "350",
          alergens: "1,3,7,9,13",
        },
      ],
    },
    {
      id: 3,
      day: "Středa",
      date: "03.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Gulášová ",
          weight: "0,3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Kuřecí závitek s křenem a pikantní klobásou, těstovin ",
          weight: "100/200",
          alergens: "1,3,6,7,9,13",
        },
        {
          type: "main",
          number: 2,
          name: "Hrachová kaše, špekáček, cibulka, pečivo ",
          weight: "350",
          alergens: "1,3,7,9,13",
        },
      ],
    },
    {
      id: 4,
      day: "Čtvrtek",
      date: "04.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Hov. vývar s těstovinou ",
          weight: "0,3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Texaská kotleta (červ. omáčka se sezamem), brambor ",
          weight: "100/300",
          alergens: "1,3,7,9,11,13",
        },
        {
          type: "main",
          number: 2,
          name: "Těstoviny zapečené s ml. masem, list. špenátem a sýrem",
          weight: "350",
          alergens: "1,3,7,9,13",
        },
      ],
    },
    {
      id: 5,
      day: "Pátek",
      date: "05.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Uzená s rýží a hráškem ",
          weight: "0,3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Koule z ml. masa,červ. zelí, br. knedlík ",
          weight: "2ks/200",
          alergens: "1,3,7,9,11,13",
        },
        {
          type: "main",
          number: 2,
          name: "Drůbeží nudličky „Asia“, rýže (pikantní) ",
          weight: "100/200",
          alergens: "1,3,7,9,13",
        },
      ],
    },
  ];
  const menu2 = [
    {
      id: 1,
      day: "Pondělí",
      date: "08.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Krupicová se zeleninou ",
          weight: "0,3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Vepř. pečeně, lišková omáčka, H.K. ",
          weight: "100/200",
          alergens: "1,3,6,7,9,13",
        },
        {
          type: "main",
          number: 2,
          name: "Selské bram. ( opeč. br., uzené, zelenina –zamíchané) ",
          weight: "150/300",
          alergens: "1,3,7,9,13",
        },
      ],
    },
    {
      id: 2,
      day: "Úterý",
      date: "09.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Hrstková ",
          weight: "0,3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Kebab z ml. masa, brambor, tzatziki ",
          weight: "100/300",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 2,
          name: "Pikantní farmářské fazole se slaninou, klobása, pečivo ",
          weight: "350",
          alergens: "1,3,7,9,13",
        },
      ],
    },
    {
      id: 3,
      day: "Středa",
      date: "10.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Krůtí ostrá ",
          weight: "0,3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Kuřecí stehenní řízky v marinádě, brambor ",
          weight: "100/300",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 2,
          name: "Zvěřinové ragů, HK ",
          weight: "100/200",
          alergens: "1,3,7,9,13",
        },
      ],
    },
    {
      id: 4,
      day: "Čtvrtek",
      date: "11.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Jarní zeleninová ",
          weight: "0,3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Kachní roláda , špenát ,bramb. noky ",
          weight: "100/300",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 2,
          name: "Sicilské makarony (česnek, řapíkatý celer, turista) ",
          weight: "350",
          alergens: "1,3,7,9,13",
        },
      ],
    },
    {
      id: 5,
      day: "Pátek",
      date: "12.06",
      meals: [
        {
          type: "soup",
          number: "Polévka",
          name: "Sedlácká ",
          weight: "0,3 l",
          alergens: "1,3,7,9,13",
        },
        {
          type: "main",
          number: 1,
          name: "Segedinský guláš, HK ",
          weight: "100/200",
          alergens: "1,3,6,7,13",
        },
        {
          type: "main",
          number: 2,
          name: "Kuřecí „Gordon – bleu, bramb. kaše ",
          weight: "130/300",
          alergens: "1,3,7,9",
        },
      ],
    },
  ];

  const MenuTable = ({ date, children }) => {
    return (
      <>
        <div className="flex justify-center">
          <span>V červenci a srpnu se budou vařit pouze 1x jídlo</span>
        </div>
        <div className="my-5">
          <table className="text-neutral-900 w-full bg-transparent shadow-lg">
            <thead className="text-xl font-bold">
              <tr className="bg-blue-600 text-center text-white border-b border-gray-600">
                <td className="p-2 rounded-t-md" colSpan={5}>
                  {date}
                </td>
              </tr>
              <tr className="bg-blue-600 text-center text-white border-b border-gray-600">
                <th className="p-2">Datum</th>
                <th className="p-2">Typ</th>
                <th className="p-2">Název</th>
                <th className="p-2 border-x">Množství</th>
                <th className="p-2">Alergeny</th>
              </tr>
            </thead>
            {children}
          </table>
          <MenuInfo />
        </div>
      </>
    );
  };

  const toggleVisibility = (partId) => {
    setVisibleParts((prev) => ({
      ...prev,
      [partId]: !prev[partId],
    }));
  };

  const sections = [
    {
      id: 1,
      title: "Druh poskytované sociální služby",
      content: (
        <>
          <p>
            Předmětem naší hlavní činnosti je poskytování{" "}
            <strong>pečovatelské služby</strong> (v souladu se zákonem č.
            108/2006 Sb., sociálních službách a vyhláškou č.505/2006 Sb., kterou
            se provádějí některá ustanovení zák.o soc. službách).
          </p>
          <p>
            <strong>Pečovatelská služba</strong> je terénní nebo ambulantní
            služba poskytovaná osobám, které mají sníženou soběstačnost z důvodu
            věku, chronického onemocnění nebo zdravotního postižení, a rodinám s
            dětmi jejichž situace vyžaduje pomoc jiné fyzické osoby. Služba
            poskytuje ve vymezeném čase v domácnostech osob a v zařízeních
            sociálních služeb vyjmenované úkony." (citace dle § 40 zákona č.
            108/2006 Sb., o sociálních službách).
          </p>
        </>
      ),
    },
    {
      id: 2,
      title: "Cíle pečovatelské služby",
      content: (
        <ul className={styles.classes.ul}>
          {goals.map((oneGoal) => (
            <li key={oneGoal.id}>{oneGoal.text}</li>
          ))}
        </ul>
      ),
    },
    {
      id: 3,
      title: "Cílové skupiny uživatelů",
      content: (
        <ul className={styles.classes.ul}>
          {targetGroups.map((oneTargetGroup) => {
            const { id, text } = oneTargetGroup;
            return <li key={id}>{text}</li>;
          })}
        </ul>
      ),
    },
    {
      id: 4,
      title: "Věková struktura uživatelů",
      content: (
        <ul className={styles.classes.ul}>
          <li>Děti do 10 let.</li>
          <li>Dospělé osoby od 27 let věku.</li>
        </ul>
      ),
    },
    {
      id: 5,
      title: "Kde služby poskytujeme",
      content: (
        <p>
          Pečovatelská služba je klientům poskytována jako{" "}
          <strong>terénní služba</strong> v jejich přirozeném prostředí, v němž
          bydlí - v jejich <strong>domácnostech</strong>, vč. domácností
          klientů, bydlících ve 2 domech s nízkonákladovými byty (dříve tzv.
          domech s pečovatelskou službou), a to v <strong>Sokolově</strong> a
          také v obcích, s nimiž organizace uzavřela dohodu o poskytování
          pečovatelské služby - t.č. <strong>Dolní Rychnov</strong>.
        </p>
      ),
    },
    {
      id: 6,
      title: "Personální zajištění poskytované služby",
      content: (
        <>
          <p>
            Máme celkem 17-18 stálých zaměstnanců, péče o rodiny s dětmi je
            zajišťována dle potřeb dobrovolnými pečovatelkami. Všechny
            pečovatelky splňují kvalifikační předpoklady pro výkon pracovníka v
            sociálních službách.
          </p>
          <p>
            Zaměstnanci poskytovatele svou činností naplňují definované poslání
            pečovatelské služby. Při poskytování pečovatelské služby se řídí
            Etickým kodexem pracovníků organizace. Všichni zaměstnanci,
            vykonávající odbornou činnost v sociálních službách splňují
            požadovanou kvalifikaci a dále se pravidelně vzdělávají.
          </p>
          <p>
            Při své práci zaměstnanci organizace postupují dle Standardů kvality
            a dalších vnitřních směrnic organizace.
          </p>
        </>
      ),
    },
    {
      id: 7,
      title: "Kapacita služby",
      content: (
        <>
          <p>
            Okamžitá kapacita poskytovaných služeb: maximální okamžitá kapacita
            13 uživatelů je dána počtem reálně přítomných pečovatelek.
          </p>
          <ul className={styles.classes.ul}>
            <li>
              V pracovní dny od 7:00 do 15:30 hodin činí maximální okamžitá
              kapacita 13 uživatelů (poskytují se všechny úkony pečovatelské
              služby).
            </li>
            <li>
              V pracovní dny od 6:00 do 7:00 hodin a od 15:30 do 22:00 hodin a
              ve dnech pracovního klidu (sobota, neděle, svátek) od 8:00 do
              22:00 hodin je maximální okamžitá kapacita 3 uživatelé (poskytují
              se zejména úkony přímé péče o klienta dle uzavřené smlouvy).
            </li>
          </ul>
          <p>Celková kapacita je max. 300 klientů.</p>
        </>
      ),
    },
    {
      id: 8,
      title: "Podmínky poskytování pečovatelské služby",
      content: (
        <>
          <p>
            Žadatel musí splňovat podmínky definované cílové skupiny a má trvalé
            bydliště na území obcí (spádová oblast), v níž poskytovatel
            poskytuje pečovatelskou službu.
          </p>
          <p>
            Zavedení pečovatelské služby je podmíněno uzavřením "Smlouvy o
            poskytnutí pečovatelské služby" - ta je pak uzavřena na základě
            žádosti zájemce o zavedení pečovatelské služby + ústní rozhovor se
            zájemcem (příp. příbuznými, pokud si tak klient přeje) - tj.
            sociální šetření, zda je klient v nepříznivé sociální situaci (§ 3,
            b, zák. č. 108/2006 Sb., o soc. službách).
          </p>
        </>
      ),
    },
    {
      id: 9,
      title: "Sociální šetření",
      content: (
        <>
          <p>
            Vykonává soc. pracovnice (společně s ved. pečovatelkou), na základě
            ústního rozhovoru s klientem, příp. jeho rodinnými příslušníky či
            jinými blízkými osobami.
          </p>
          <p>
            Osobu, která není schopna sama jednat, zastupuje zákonný zástupce
            nebo opatrovník.
          </p>
          <p>
            Pečovatelská služba je pak klientovi zavedena v rozsahu - dle jeho
            přání a skutečných individuálních potřeb.
          </p>
          <p>
            Je sjednána smlouva o poskytování pečovatelské služby, na základě
            níž jsou pak následně poskytovány potřebné úkony pečovatelské
            služby, na kterých se obě strany dohodnou.
          </p>
          <p>
            Průběh poskytování peč. služby je klientovi individuálně plánován -
            po jeho dohodě společně s tzv. klíčovým pracovníkem organizace
            (vedoucí pečovatelka, pečovatelka).
          </p>
          <p>
            V rámci této péče jsou stanovovány tzv. cíle poskytované péče,
            kterých by za pomocí poskytované služby chtěl klient dosahovat a
            také je pravidelně kontrolováno a vyhodnocováno jejich naplňování.
          </p>
        </>
      ),
    },
    {
      id: 10,
      title: "Smlouva o poskytnutí pečovatelské služby",
      content: (
        <>
          <p>
            Písemně uzavřená mezi klientem a poskytovatelem obsahuje veškeré
            náležitosti - dle zákona č.108/2006 Sb., o soc. službách, vč.
            stanovení výše úhrady za služby a způsobu placení.
          </p>
          <p>
            Za poskytování pečovatelské služby hradí klienti úhradu za provedené
            úkony, ve výši, sjednané ve smlouvě uzavřené s poskytovatelem služby
            (dle Sazebníku úkonů- souladu s ust. § 75 zák.o soc. službách a
            vyhl. č. 505/2006 Sb.).
          </p>
          <p>
            "Sazebník úkonů" je přílohou uzavřené smlouvy o poskytování peč.
            smlouvy kterou na požádání také vydají zaměstnanci organizace.
          </p>
        </>
      ),
    },
    {
      id: 11,
      title: "Odmítnutí uzavření smlouvy",
      content: (
        <>
          <p>
            Poskytovatel může odmítnout uzavřít smlouvu o poskytování
            pečovatelské služby, pokud dle § 91, odst.3, zákona 108/2006 Sb., o
            soc. službách, ve zn. pozd. předpisů:
          </p>
          <ul className={styles.classes.ul}>
            <li>
              neposkytuje požadovanou službu, o kterou osoba žádá (a to s
              ohledem na vymezený okruh v registru poskytovatelů soc. služeb);
            </li>
            <li>
              nemá dostatečnou kapacitu k poskytnutí sociální služby, o kterou
              osoba žádá;
            </li>
            <li>
              pokud žadateli o službu organizace již vypověděla smlouvu a to v
              době kratší než 6 měsíců před touto žádostí z důvodů porušování
              povinností vyplývajících ze smlouvy.
            </li>
          </ul>
        </>
      ),
    },
    {
      id: 12,
      title: `Jídelní lístek od: ${menuDate}`,
      content: (
        <div className="mx-auto text-lg">
          <h2 className="w-fit mx-auto text-4xl border-b-2 border-amber-500 mb-3 uppercase">
            Jídelní lístek
          </h2>
          <p className="text-center font-semibold text-amber-700 mb-6 bg-gray-300 w-fit px-4 py-2 mx-auto  rounded-md shadow-xl">
            Tento jídelní lístek je pouze pro klienty pečovatelské služby!
          </p>

          {/* 1 týden */}
          <MenuTable date={menuDate}>
            <tbody className="">
              {menu1 &&
                menu1.map((d) => {
                  if (!d.meals || d.meals.length === 0) return null;

                  const rowspan = d.meals.length;

                  return d.meals.map((m, i) => {
                    // modulo pro barvy řádků  v jídelníčku
                    const zebra =
                      d.id % 2 === 0
                        ? "bg-blue-200 border border-gray-400"
                        : "bg-blue-100 border border-gray-400";
                    const isLast = i === d.meals.length - 1;
                    const cell = `p-2 ${isLast ? "border-b border-gray-600" : ""}`;
                    return (
                      <tr key={`${d.id}-${i}`} className={`${zebra}`}>
                        {/* 1) Sloupec Den+Datum jen u prvního řádku, sdílený přes rowSpan */}
                        {i === 0 && (
                          <td
                            className={`border-y border-y-gray-600 border-x border-x-gray-400 text-center font-semibold content-center`}
                            rowSpan={rowspan}
                          >
                            {d.day}
                            <br />
                            {d.date}.
                          </td>
                        )}

                        {/* 2) Ostatní sloupce pro každé jídlo */}
                        <td className={cell}>
                          {m.type === "soup"
                            ? "Polévka"
                            : `Hlavní jídlo ${m.number}`}
                        </td>
                        {/* <td className="p-2 border">{m.number || "—"}</td> */}
                        <td
                          className={`${cell} font-semibold border-x border-x-gray-400`}
                        >
                          {m.name || "—"}
                        </td>
                        <td
                          className={`${cell} text-center border-x border-x-gray-400`}
                        >
                          {m.weight || "—"}
                        </td>
                        <td className={`${cell} text-center`}>
                          {m.alergens || "—"}
                        </td>
                      </tr>
                    );
                  });
                })}
            </tbody>
          </MenuTable>

          <hr className="mb-5 mt-5 w-3/5 mx-auto" />

          {/* 2 týden */}
          {menu2 && (
            <MenuTable date="">
              <tbody className="">
                {menu2.map((d) => {
                  if (!d.meals || d.meals.length === 0) return null;

                  const rowspan = d.meals.length;

                  return d.meals.map((m, i) => {
                    // modulo pro barvy řádků  v jídelníčku
                    const zebra =
                      d.id % 2 === 0
                        ? "bg-blue-200 border border-gray-400"
                        : "bg-blue-100 border border-gray-400";
                    const isLast = i === d.meals.length - 1;
                    const cell = `p-2 ${isLast ? "border-b border-gray-600" : ""}`;
                    return (
                      <tr key={`${d.id}-${i}`} className={`${zebra}`}>
                        {/* 1) Sloupec Den+Datum jen u prvního řádku, sdílený přes rowSpan */}
                        {i === 0 && (
                          <td
                            className={`border-y border-y-gray-600 border-x border-x-gray-400 text-center font-semibold content-center`}
                            rowSpan={rowspan}
                          >
                            {d.day}
                            <br />
                            {d.date}.
                          </td>
                        )}

                        {/* 2) Ostatní sloupce pro každé jídlo */}
                        <td className={cell}>
                          {m.type === "soup"
                            ? "Polévka"
                            : `Hlavní jídlo ${m.number}`}
                        </td>
                        {/* <td className="p-2 border">{m.number || "—"}</td> */}
                        <td
                          className={`${cell} font-semibold border-x border-x-gray-400`}
                        >
                          {m.name || "—"}
                        </td>
                        <td
                          className={`${cell} text-center border-x border-x-gray-400`}
                        >
                          {m.weight || "—"}
                        </td>
                        <td className={`${cell} text-center`}>
                          {m.alergens || "—"}
                        </td>
                      </tr>
                    );
                  });
                })}
              </tbody>
            </MenuTable>
          )}
        </div>
      ),
    },
  ];

  return (
    <section id="services" className="px-2 py-3 mb-10 bg-cyan-800 text-white">
      <div className="container mx-auto">
        <div className="text-center my-3">
          <h2 className="w-fit mx-auto text-4xl border-b-2 border-amber-500 mb-6 uppercase">
            Poslání a služby
          </h2>
        </div>

        <div className={containerClasses}>
          <p className="mb-2">
            <strong>Pečovatelskou službu</strong> poskytujeme již od roku 2008,
            kdy byla organizace{" "}
            <strong>Centrum sociálních služeb Sokolov o.p.s.</strong> založena.
            Naším cílem je poskytnutí pomoci seniorům, chronicky nemocným a
            zdravotně postiženým občanům, aby mohli žít důstojně, běžným
            způsobem, a co nejdéle ve svém domácím prostředí, na které jsou
            zvyklí. Pomoc či podpora je našim klientům poskytována v rozsahu dle
            jejich přání, potřeb a na základě jejich představ řešení jejich
            životní situace. Vytvářením vhodných podmínek se klientům umožňuje
            také aktivní účast na společenském a kulturním životě, na pracovní
            činnosti podle jejich zájmů a zdravotního stavu, aby tak bylo
            podpořeno zachování kvality života našich klientů.
          </p>
          <p className="mb-2">
            Obecným cílem pečovatelské služby a výsledkem spolupráce s klientem
            by mělo být klientovo začlenění, odpovídající běžnému způsobu života
            lidí obdobného věku v obci. Vyřešení jeho nepříznivé sociální
            situace, vyrovnání příležitostí a podobně.
          </p>
        </div>

        {sections.map((section) => (
          <CollapsibleServices
            key={section.id}
            id={section.id}
            title={section.title}
            isVisible={visibleParts[section.id]}
            toggleVisibility={toggleVisibility}
            className={containerClasses}
          >
            {section.content}
          </CollapsibleServices>
        ))}

        <hr className="mb-10 mt-5 w-3/4 mx-auto" />

        {/* karty se službami */}
        {
          <div className="relative md:w-3/4 mx-auto text-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
              {cards.map((card) => (
                <div
                  key={card.id}
                  className="flex justify-center items-center mb-10"
                >
                  <ServiceCard
                    image={card.image}
                    alt={card.alt}
                    title={card.alt}
                    text={card.text}
                    onClick={() => openGallery(card.id)}
                  />
                </div>
              ))}
            </div>
          </div>
        }
      </div>

      {/* Modal pro galerii - pokud bude potřeba */}
      <ModalGallery
        open={isGalleryModalOpen}
        onClose={() => setIsGalleryModalOpen(false)}
        initialCardId={selectedCardId}
      />
    </section>
  );
};

export default Services;
